import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { CreatePostRequest } from '../domain/dtos/create-post-request'
import { PostResponse } from '../domain/dtos/post-response'
import { UpdatePostRequest } from '../domain/dtos/update-post-request'
import { Envs } from '../envs'

export class SavePost {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(payload: CreatePostRequest | UpdatePostRequest, postId: string | null): Promise<PostResponse> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .request({
          url: this.makeUrl(postId),
          body: payload,
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: postId ? HttpMethod.PUT : HttpMethod.POST,
        })
        .then((response) => {
          if (!response.data || ![HttpStatusCode.CREATED, HttpStatusCode.OK].includes(response.statusCode)) {
            return reject(`Ocorreu um erro ao ${postId ? 'atualizar' : 'salvar'} o conteúdo`)
          }

          return resolve(this.makeData(response.data))
        })
        .catch(() => {
          return reject(`Ocorreu um erro ao ${postId ? 'atualizar' : 'salvar'} o conteúdo`)
        })
    })
  }

  private makeData = (data: PostResponse): PostResponse => {
    return data
  }

  private makeUrl(postId: string | null) {
    return postId ? `${Envs.BFF_MEMBERS_AREA_URL}/hub/posts/${postId}` : `${Envs.BFF_MEMBERS_AREA_URL}/hub/posts`
  }
}
